import { Skeleton } from '@/components/ui/skeleton';

export default function LoadingCustomerOrderDetail() {
  return (
    <div className='px-4'>
      <div className='flex flex-col gap-2'>
        <Skeleton className='h-4 w-1/2 md:h-5 lg:h-5 xl:h-7' />
        <Skeleton className='h-3 w-1/4 md:h-4 lg:h-4 xl:h-6' />
        <div className='mt-5 flex gap-2 md:mt-7 lg:mt-7 xl:mt-10'>
          <Skeleton className='h-6 w-full md:h-8 lg:h-8 xl:mt-10' />
          <Skeleton className='h-6 w-full md:h-8 lg:h-8 xl:mt-10' />
        </div>
        <Skeleton className='my-3 h-2 w-full md:my-4 lg:my-6 xl:my-8' />
        <Skeleton className='h-3 w-1/2 md:h-4 lg:h-5 xl:h-7' />
        <div className='mt-5 flex flex-col gap-3'>
          <div className='flex gap-2'>
            <Skeleton className='h-6 w-full' />
            <Skeleton className='h-6 w-full' />
          </div>
          <div className='flex gap-2'>
            <Skeleton className='h-6 w-full' />
            <Skeleton className='h-6 w-full' />
          </div>
        </div>
        <Skeleton className='my-3 h-2 w-full md:my-4 lg:my-6 xl:my-8' />
        <Skeleton className='h-7 w-1/4' />
        <div className='mt-4 flex w-full items-center justify-between'>
          <div className='flex w-full gap-2'>
            <Skeleton className='h-16 w-16' />
            <div className='flex w-full flex-col gap-2'>
              <Skeleton className='h-6 w-1/2' />
              <Skeleton className='h-6 w-1/2' />
            </div>
          </div>
          <div className='flex w-full flex-col items-end gap-2'>
            <Skeleton className='h-6 w-1/2' />
            <Skeleton className='h-6 w-1/4' />
          </div>
        </div>
        <Skeleton className='my-3 h-2 w-full md:my-4 lg:my-6 xl:my-8' />
        <div className='flex flex-col gap-2'>
          <Skeleton className='h-7 w-1/4' />
          <div className='mt-4 flex items-center justify-between'>
            <Skeleton className='h-5 w-1/4' />
            <Skeleton className='h-5 w-1/4' />
          </div>
          <div className='mt-2 flex items-center justify-between md:mt-2 lg:mt-2 xl:mt-4'>
            <Skeleton className='h-5 w-1/4' />
            <Skeleton className='h-5 w-1/4' />
          </div>
          <div className='mt-2 flex items-center justify-between md:mt-2 lg:mt-2 xl:mt-4'>
            <Skeleton className='h-5 w-1/4' />
            <Skeleton className='h-5 w-1/4' />
          </div>
        </div>
      </div>
    </div>
  );
}
